<template>
  <v-container fluid class="batchpayment-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs color="primary">
          <v-tab :href="`#tab-payment`" class="mr-5">
            <v-icon class="mr-3">mdi-text-box-outline</v-icon>
            Payment
          </v-tab>
          <v-tab class="mr-5" :href="`#tab-items`" >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Items
          </v-tab>
          <v-tab-item :value="'tab-payment'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Payment</p>
                      <v-select
                        readonly
                        class="mb-4"
                        :items="paymenttype"
                        v-model="edit_payment.paymenttype"
                        v-on:change="onChangeBatchPayment($event, 'paymenttype')"
                        v-bind:error="errorindex == 0"
                        outlined
                        dense
                        placeholder="Type"
                        persistent-hint
                        single-line
                        hint="Please choose the payment type"
                      >
                      </v-select>
                      <v-menu
                        ref="menu_paymentdate"
                        v-model="menu_paymentdate"
                        :close-on-content-click="false"
                        :return-value.sync="paymentdate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            outlined
                            dense
                            v-model="paymentdate"
                            label="BatchPayment Date"
                            v-bind="attrs"
                            v-bind:value="paymentdate"
                            v-on:change="
                              onChangeBatchPayment($event, 'paymentdate')
                            "
                            v-bind:error="errorindex == 1"
                            v-on="on"
                            single-line
                            hint="Please choose the payment date"
                            persistent-hint
                          >
                            </v-text-field
                          >
                        </template>
                        <v-date-picker
                          v-model="paymentdate"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu_paymentdate = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="
                              onChangeBatchPayment(
                                paymentdate,
                                'paymentdate'
                              );
                              $refs.menu_paymentdate.save(paymentdate);
                            "
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                      <v-switch
                        color="primary"
                        v-on:change="onChangeBatchPayment($event, 'isTaxable')"
                        v-model="edit_payment.isTaxable"
                        v-bind:value="edit_payment ? edit_payment.isTaxable : false"
                        hint="Taxable"
                        persistent-hint
                      ></v-switch>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items="accounts.filter(account=>account.accountsubclass=='Bank').map(x => {
                          return {text: x.accountname, value: x._id};
                          })"
                        v-model="edit_payment.accountid"
                        v-on:change="onChangeBatchPayment($event, 'accountid')"
                        v-bind:error="errorindex == 2"
                        outlined
                        dense
                        placeholder="Account"
                        persistent-hint
                        single-line hint="Please choose the account">
                      </v-select>
                      <v-select
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="locations.map(x => {return {text: x.locationname, value: x._id};})"
                        v-model="edit_payment.locationid"
                        v-on:change="onChangeBatchPayment($event, 'locationid')"
                        v-bind:error="errorindex == 6"
                        outlined
                        dense
                        placeholder="Location"
                        persistent-hint
                        single-line hint="Please choose the location">
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-text-field
                        :readonly="isNotEditable"
                        class="mb-4"
                        v-model="edit_payment.refnum"
                        v-on:change="onChangeBatchPayment($event, 'refnum')"
                        outlined
                        dense
                        placeholder="Refnum"
                        persistent-hint
                        single-line hint="Enter the reference">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items="['New', 'Pending', 'Approved', 'Completed']"
                        v-model="edit_payment.paymentstatus"
                        v-on:change="onChangeBatchPayment($event, 'paymentstatus')"
                        outlined
                        dense
                        placeholder="Status"
                        persistent-hint
                        single-line
                        hint="Please choose the status"
                      >
                      </v-select>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/batchpayment/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        :loading="isReceiving"
                        class="button-shadow"
                        color="primary"
                        @click="updateBatchPayment()"
                      >
                        Save
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-items'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row>
                  <v-col md="6">
                    <p class="text-h5">Items</p>
                  </v-col>
                  <v-col cols="6" sm="6" md="6" lg="6" class="d-flex flex-end justify-md-end overflow-auto" align="right">
                    <v-btn
                      class="button-shadow mr-1"
                        to="/batchpayment/list"
                        replace
                        color="primary"
                      >
                        Done
                    </v-btn>
                  </v-col>
                  </v-row>
                  <v-data-table
                        :headers="header_items"
                        :items="transactions"
                        :items-per-page="100"
                        :footer-props="footer"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteTransaction" width="500">
                            <v-card>
                              <v-card-title> Delete this Item? </v-card-title>
                              <v-card-text>
                                {{ delete_transaction.itemdesc }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteTransaction = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteTransaction(delete_transaction)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.itemimage="{ item }">
                          <v-img
                            v-bind:lazy-src="item.itemimage"
                            min-width="50"
                            max-width="100"
                            v-bind:src="item.itemimage"
                          ></v-img>
                        </template>
                        <template v-slot:item.accountid="{ item }">
                          {{ accounts.length>0 ? accounts.find(account=>account._id == item.accountid)['accountname'] : '' }}
                        </template>
                        <template v-slot:item.itemamount="{ item }">
                          {{ item.itemamount.toFixed(2) }}
                        </template>
                        <template v-slot:item.transdate="{ item }">
                          {{ item.transdate!=null ? new Date(item.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            v-if="isEditable"
                            icon
                            color="primary"
                            @click="editTransactionDialog(item)"
                          >
                            <v-icon>mdi-pencil-outline</v-icon>
                          </v-btn>
                          <v-btn
                            v-if="isEditable"
                            icon
                            color="primary"
                            @click="deleteTransactionDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-dialog
        v-model="isEditTransaction"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    readonly
                    v-model="edit_transaction.transtype"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Type"
                    persistent-hint
                    single-line hint="Type">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    readonly
                    v-model="edit_transaction.transname"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Name"
                    persistent-hint
                    single-line hint="Name">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.transamount"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Amount"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditTransaction=false; edit_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="updateTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isUploadFile"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Upload File</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                <v-file-input label="File input" v-model="upload.file" v-on:change="onChangeFile" accept=".pdf" />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="upload.filename"
                    label="File Name"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isUploadFile = false; upload.file=null; upload.filename=''"
            >
              Close
            </v-btn>
            <v-btn
              :disabled="upload.file==null"
              color="blue darken-1"
              text
              @click="uploadFile"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { formatStdDate } from '@/mixins/date';
import router from "@/Routes";

export default {
  data() {
    return {
      header_items: [
        { text: 'Date', value: 'transdate', width: '8%'},
        { text: 'Type', value: 'transtype'},
        { text: 'Name', value: 'transname'},
        { text: 'Amount', value: 'transamount', width: '10%'},
        { text: "Actions", value: "actions", sortable: false, width: '10%' },
      ],
      change_payment: {},
      edit_payment: {},
      
      deletefile: {},
      searchvendor: {},
      initvalue: {},
      edit_transaction: {},
      new_transaction: {},
      delete_transaction: {},

      upload: {filename: null,file: null},
      files: [],
      paymenttype: ["Batch Payment"],
      transactions: [],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      route: 0,



      menu_transdate: false,
      menu_transdate_edit: false,
      
      accountsubclass: null,
      accountsubclass2: null,

      paymentdate: null,
      paymentduedate: null,
      menu_paymentdate: false,
      menu_paymentduedate: false,


      isEditTransaction: false,
      isAddTransaction: false,
      isUploadFile: false,
      isDeleteFile: false,
      isDeleteTransaction: false,    
      errorindex: undefined,
    };
  },
  computed: {
    ...mapState("Account", ["accounts"]),
    ...mapState("BatchPayment", ["isReceiving"]),
    ...mapState("Department", ["departments"]),
    ...mapState("Item", ["items"]),
    ...mapState("Location", ["locations"]),
    ...mapState("User", ["users"]),
    ...mapState("Vendor", ["vendors"]),
    isNotEditable(){
      let result = ['New','Credit','Partial','Pending','Audit','Void'].indexOf(this.initvalue.paymentstatus) == -1;
      return result;
    },
    isEditable(){
      let result = ['New','Partial', 'Audit', 'Void'].indexOf(this.initvalue.paymentstatus) >= 0;
      console.log(result);
      return result;
    }
  },
  methods: {
    ...mapActions("Account", ["getAccountsRequest"]),
    ...mapActions("BatchPayment", ["deleteBatchPaymentTransactionRequest", "getBatchPaymentRequest", "insertBatchPaymentTransactionRequest", "updateBatchPaymentRequest", "updateBatchPaymentTransaction"]),
    ...mapActions("Brand", ["getBrandsRequest"]),
    ...mapActions("Department", ["getDepartmentsRequest"]),
    ...mapActions("File", ["insertRouteFile", "deleteFileRequest"]),
    ...mapActions("Item", ["getItemsRequest"]),
    ...mapActions("Location", ["getLocationsRequest"]),
    ...mapActions("User", ["getUsersRequest"]),
    checkError() {
      if (!this.accessname) {
        this.errorindex = 0;
        return false;
      }
      if (!this.accesspath) {
        this.errorindex = 1;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    checkTransaction(){
      if(!this.new_transaction.accountid){
        this.haserrors = true;
        this.errorindex = 11;
        return false;
      }
      if(!this.new_transaction.itemdesc){
        this.haserrors = true;
        this.errorindex = 12;
        return false;
      }
      if(!this.new_transaction.itemamount){
        this.haserrors = true;
        this.errorindex = 13;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    calculateAmount() {
      if(this.route==0)this.new_transaction.itemamount = this.new_transaction.itemquantity * this.new_transaction.itemprice;
      else if(this.route==1)this.edit_transaction.itemamount = this.edit_transaction.itemquantity * this.edit_transaction.itemprice;
      this.itemamount = this.edit_transaction.itemamount;  
    },
    clearTransaction() {
      this.edit_transaction = {};
      this.new_transaction = {};
    },
    deleteTransactionDialog(item) {
      this.isDeleteTransaction = true;
      this.delete_transaction = {_id: item._id, itemname: item.itemname, itemdesc: item.itemdesc};
    },
    async deleteTransaction(payload) {
      this.isDeleteTransaction = false;
      let response = await this.deleteBatchPaymentTransactionRequest(payload);
      let index = this.transactions.findIndex((trans) => trans._id == response._id);
      this.transactions.splice(index, 1);
      this.getBatchPaymentRequest(this.initvalue._id);
    },
    editTransactionDialog(item) {
      this.edit_transaction = Object.assign({}, item);
      this.isEditTransaction = true;
    },
    onChangeFile(file) {
      if (!file) this.upload.file = null;
      else this.upload.file = file;
    },
    onChangeBatchPayment(value, field) {
      this.change_payment[field] = value;
    },

  
    async updateBatchPayment() {
      this.change_payment._id = this.initvalue._id;
      await this.updateBatchPaymentRequest(this.change_payment);
      router.push("/batchpayment/list");
    },
    async updateTransaction() {
      this.isEditTransaction = false;
      let json = {_id: this.edit_transaction._id, transamount: this.edit_transaction.transamount};
      let response = await this.updateBatchPaymentTransaction(json);
      let index = this.transactions.findIndex((x) => x._id == response._id);
      this.transactions.splice(index, 1, response);
      this.clearTransaction();
      this.getBatchPaymentRequest(this.initvalue._id);
    },
    async uploadFile(){
      this.isUploadFile = false;
      this.upload.id = this.initvalue._id;
      this.upload.route = 'payment';
      let file = await this.insertRouteFile(this.upload);
      this.files.push(file);
      this.upload = {filename: null,file: null};
      this.getBatchPaymentRequest(this.initvalue._id);
    },
  },

  async created() {
    this.initvalue = this.$route.params;
    if (!this.initvalue._id) this.$router.push({ name: "BatchPaymentList" });
    this.edit_payment = Object.assign({}, this.initvalue);
    this.paymentdate = formatStdDate(this.initvalue.paymentdate);

    let result = await this.getBatchPaymentRequest(this.initvalue._id);
    this.files = Object.assign([], result.files);
    this.transactions = Object.assign([], result.transactions);
    if (this.accounts.length==0) await this.getAccountsRequest();
    if (this.locations.length==0) await this.getLocationsRequest();
    if (this.users.length==0) await this.getUsersRequest();    
  },
};
</script>

<style src="./Edit.scss" lang="scss"></style>
